import { jsx as g } from "react/jsx-runtime";
import { useState as t, useCallback as o, createContext as F, useContext as $ } from "react";
import { v4 as n } from "uuid";
const s = F(void 0), y = ({ children: r }) => {
  const [d, i] = t(!1), [c, a] = t(), [C, I] = t(), [u, l] = t(), [f, p] = t(), m = o((e) => {
    a(e || `card-headline-${n()}`);
  }, []), h = o((e) => {
    I(e || `card-description-${n()}`);
  }, []), v = o((e) => {
    l(e || `card-content-${n()}`);
  }, []), x = o((e) => {
    p(e || `card-footer-${n()}`);
  }, []);
  return /* @__PURE__ */ g(
    s.Provider,
    {
      value: {
        isAnyOfChildrenFocused: d,
        setIsAnyOfChildrenFocused: i,
        headlineId: c,
        descriptionId: C,
        contentId: u,
        footerId: f,
        registerHeadlineId: m,
        registerDescriptionId: h,
        registerContentId: v,
        registerFooterId: x
      },
      children: r
    }
  );
}, A = () => {
  const r = $(s);
  if (!r)
    throw new Error("useCard must be used within a CardProvider");
  return r;
};
export {
  y as CardProvider,
  A as useCard
};
//# sourceMappingURL=index.es795.js.map
